export default {
	data() {
		return {
			//所有课程的数据
			data: [],
			//已经被选到的数组
			value: [],
			//学员的id字符串有多个
			idcards: '',
			//学员选课的批次备注
			stuBatch: '',
			renderFunc(h, option) {
				return <span > {option.key} - {option.label} </span>;
			},
			fullscreenLoading: false,
			
		};
	},

	methods: {
		handleChange(value, direction, movedKeys) {
			// console.log("11",value, direction, movedKeys);
			// console.log("???",this.value);
		},
		//选课
		chooseClass() {
			//判断选课，学员，批次备注
			if (this.value.length == 0) {
				this.$message({
					message: '至少选择一门课程',
					type: 'warning'
				});
			} else if (this.idcards.trim().split('\n').length == 0 || this.idcards.trim().split('\n')[0] == '') {
				this.$message({
					message: '至少填写一个学员身份证',
					type: 'warning'
				});
			} else if (this.stuBatch == '') {
				this.$message({
					message: '请填写批次备注',
					type: 'warning'
				});
			} else {
				//发送后台的数据
				let data = {
					token: this.$store.state.authority_management,
					idcard_arr: JSON.stringify(this.idcards.trim().split('\n')),
					category_ids: JSON.stringify(this.value),
					remarks: this.stuBatch,
					shop_id: this.$store.state.store.id
				}
				// console.log(this.value);
				// return false;
				//创建批次和选课
				this.$post('selected/create_by_idcard', data).then(res => {
					let str = '';
					console.log(res)
					if(res.data.result.status == 'fails'){
						str = '以下学员没有注册：' +  res.data.result.noExistIdCard + '。' +'以下身份证格式不正确：' +  res.data.result.errorIdCard
					}else{
						str = '选课成功' 
					}
					this.$alert(res.data.result.result, str, {
						confirmButtonText: '确定',
					});
				})
			}
		},
		//获取所有课程
		getAllClass() {
			this.fullscreenLoading = true;
			this.$post('product_category/search_products', {
				token: this.$store.state.authority_management,
				offset: 0,
				length: 99999,
				shop_id:this.$store.state.store.id,
				available: 1
			}).then(res => {
				this.fullscreenLoading = false;
				let data = res.data.result.data;
				// console.log(data)
				for (let i = 0; i < data.length; i++) {
					data[i].key = i;
					data[i].label = data[i].category_name;
					this.data.push(data[i]);
				}
				// this.data=data;
			})
		},
		leftChange(data) {
			// console.log(data);
		}
	},
	created() {
		this.getAllClass();
	}
};
